/** Registro de vistas por nombre: asocia cada nombreComponente del menú a su import lazy y lo resuelve con getComponent(). */
import { lazy, type LazyExoticComponent, type FC } from "react";

const registry: Record<string, LazyExoticComponent<FC>> = {
  Dashboard: lazy(() => import("@/views/dashboard")),
  Schedule: lazy(() => import("@/views/schedule")),
  Vehicles: lazy(() => import("@/views/vehicles")),
  TableServiceOrder: lazy(() => import("@/views/serviceorder")),
  ServProduct: lazy(() => import("@/views/servproduct")),
  Users: lazy(() => import("@/views/users")),
  CheckList: lazy(() => import("@/views/checklist")),
  Customers: lazy(() => import("@/views/customers")),
  Prices: lazy(() => import("@/views/prices")),
  MisTrabajos: lazy(() => import("@/views/mitrabajo")),
};

export const getComponent = (name: string): LazyExoticComponent<FC> | undefined => registry[name];
